import { render } from "./account-view.vue?vue&type=template&id=8d99b220"
import script from "./account-view.vue?vue&type=script&lang=js"
export * from "./account-view.vue?vue&type=script&lang=js"

import "./account-view.vue?vue&type=style&index=0&id=8d99b220&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__